export const COLLAPSED_SIDEBAR_WIDTH = '58px';
export const EXTENDED_SIDEBAR_WIDTH = '200px';
export const NAVBAR_HEIGHT = '65px';
